import React from 'react';

function LayoutBase({ as: Component = 'div', className = '', children, ...props }) {
  return (
    <Component className={className} {...props}>
      {children}
    </Component>
  );
}

export default LayoutBase;
